export enum PAGE_TYPE {
    PDP = 'pdp',
    PLP = 'plp',
    HOME = 'home',
    CMS = 'cms',
    SRP = 'srp',
    OTHER = 'other'
}
